import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './styles.module.scss';
import { addressToSentenceCase } from 'helpers/formatters';

const ListingDetailHeadInfo = ({
  price,
  addressLine1,
  addressLine2,
  baths,
  beds,
  square,
  sqftRange,
  sourceSection,
  mlsLastUpdate,
  activityStatus,
  closingPrice,
}) => (
  <div className={styles.container}>
    <div className={styles.top}>
      <div testid="head_price" className={styles.price}>
        {closingPrice && activityStatus == 'Closed' ? closingPrice : price}
      </div>
      <div className={styles.right}>
        {!!activityStatus && (
          <span
            className={classNames(styles.activityStatus, styles[activityStatus?.replace(/ /g, '')])}
          >
            {activityStatus}
          </span>
        )}
      </div>
    </div>
    <div className={styles.shortNumbers}>
      {!!beds && (
        <>
          <span>
            <b testid="head_beds">{beds}</b>
            {Number(beds) === 1 ? 'bed' : 'beds'}
          </span>
          {baths || square ? <div className={styles.seperator} /> : null}
        </>
      )}
      {!!baths && (
        <>
          <span>
            <b testid="head_baths">{baths}</b>
            {Number(baths) === 1 ? 'bath' : 'baths'}
          </span>
          {!!square && <div className={styles.seperator} />}
        </>
      )}
      {!!square && (
        <>
          <span>
            <b testid="head_feet">{square}</b>
          </span>
        </>
      )}
      {!!sqftRange && (
        <>
          <div className={styles.seperator} />
          <span>
            <b testid="head_feet">{sqftRange}</b>
            sqft
          </span>
        </>
      )}
    </div>
    <div testid="head_address" className={styles.address}>
      <p className={styles.lineOne}>{addressToSentenceCase(addressLine1)}</p>
      <p className={styles.lineTwo}>{addressToSentenceCase(addressLine2)}</p>
    </div>

    <div testid="descr_info" className={styles.descriptionInfo}>
      <div testid="descr_info" className={styles.descriptionInfo}>
        {sourceSection.map((val, index) => {
          const isImage =
            val?.endsWith('.png') ||
            val?.endsWith('.jpg') ||
            val?.endsWith('.jpeg') ||
            val?.endsWith('.webp') ||
            val?.endsWith('.gif');

          return (
            <>
              {isImage ? <img src={val} alt="MLS Logo" width="100px" /> : <span>{val}</span>}

              {index < sourceSection.length - 1 && <span className={styles.seperatorSmall}>•</span>}
            </>
          );
        })}
      </div>
    </div>
    {!!mlsLastUpdate && (
      <div testid="mls_last_update" className={styles.mlsLastUpdate}>
        {mlsLastUpdate}
      </div>
    )}
  </div>
);

ListingDetailHeadInfo.propTypes = {
  price: PropTypes.string,
  addressLine1: PropTypes.string,
  addressLine2: PropTypes.string,
  baths: PropTypes.number,
  beds: PropTypes.number,
  square: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  sqftRange: PropTypes.string,
  sourceSection: PropTypes.array,
  mlsLastUpdate: PropTypes.string,
  activityStatus: PropTypes.string,
  closingPrice: PropTypes.string,
};

ListingDetailHeadInfo.defaultProps = {
  price: '',
  addressLine1: '',
  addressLine2: '',
  baths: 0,
  beds: 0,
  square: '',
  sqftRange: '',
  sourceSection: [],
  mlsLastUpdate: '',
  activityStatus: '',
  closingPrice: '',
};

export default ListingDetailHeadInfo;
